import { useState } from "react";
import { Link } from "react-router-dom";
import { X, ChevronDown, Phone, CalendarCheck } from "lucide-react";
import { CONTACT, ICONS, IMG, THEME, servicesOf } from "@/data/site";

const DeptGroup = ({ dept, onClose }) => {
  const t = THEME[dept];
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-line" data-testid={`drawer-group-${dept}`}>
      <button onClick={() => setOpen(!open)} data-testid={`drawer-toggle-${dept}`} className="flex w-full items-center justify-between py-4">
        <span className="flex items-center gap-2 text-lg font-semibold text-ink"><span className={`h-2.5 w-2.5 rounded-full ${t.bg}`} /> <span className="font-en">{t.menuEn}</span><span className="text-sm font-normal text-muted2">· {t.labelHi}</span></span>
        <ChevronDown className={`h-5 w-5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="pb-3">
          <Link to={t.path} onClick={onClose} data-testid={`drawer-dept-${dept}`} className={`mb-2 block rounded-xl px-3 py-2 text-sm font-semibold ${t.tint} ${t.text}`}>{t.deptHi} — सभी सेवाएँ →</Link>
          {servicesOf(dept).map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <Link key={s.slug} to={`/services/${s.slug}`} onClick={onClose} data-testid={`drawer-service-${s.slug}`} className="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-sand">
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${t.tint} ${t.text}`}><Icon className="h-4 w-4" /></span>
                <span className="text-[15px] text-ink">{s.titleHi}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const MobileDrawer = ({ open, onClose }) => (
  <div className={`fixed inset-0 z-[60] lg:hidden ${open ? "" : "pointer-events-none"}`}>
    <div onClick={onClose} className={`absolute inset-0 bg-black/40 transition-opacity ${open ? "opacity-100" : "opacity-0"}`} />
    <aside id="mobile-navigation" data-testid="mobile-drawer" aria-hidden={!open} className={`absolute right-0 top-0 flex h-full w-[88%] max-w-sm flex-col bg-white transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}>
      <div className="flex items-center justify-between border-b border-line px-5 py-4">
        <img src={IMG.logo} alt="Medicity Hospital" className="h-10 w-auto" />
        <button onClick={onClose} data-testid="mobile-drawer-close" aria-label="Close" className="flex h-10 w-10 items-center justify-center rounded-full border border-line"><X className="h-5 w-5" /></button>
      </div>
      <nav className="flex-1 overflow-y-auto px-5">
        <Link to="/" onClick={onClose} data-testid="drawer-home" className="block border-b border-line py-4 text-lg font-semibold"><span className="font-en">Home</span> <span className="text-sm font-normal text-muted2">· होम</span></Link>
        <DeptGroup dept="eye" onClose={onClose} />
        <DeptGroup dept="surgery" onClose={onClose} />
        <Link to="/doctors" onClick={onClose} data-testid="drawer-doctors" className="block border-b border-line py-4 text-lg font-semibold"><span className="font-en">Doctors</span> <span className="text-sm font-normal text-muted2">· डॉक्टर</span></Link>
        <Link to="/contact" onClick={onClose} data-testid="drawer-contact" className="block border-b border-line py-4 text-lg font-semibold"><span className="font-en">Contact</span> <span className="text-sm font-normal text-muted2">· संपर्क</span></Link>
        <Link to="/sitemap" onClick={onClose} data-testid="drawer-sitemap" className="block py-4 text-lg font-semibold"><span className="font-en">Sitemap</span> <span className="text-sm font-normal text-muted2">· साइटमैप</span></Link>
      </nav>
      <div className="space-y-2 border-t border-line p-5">
        <Link to="/#appointment" onClick={onClose} data-testid="drawer-book-button" className="btn btn-maroon w-full"><CalendarCheck className="h-4 w-4" /> अपॉइंटमेंट बुक करें</Link>
        <a href={`tel:${CONTACT.phoneDial}`} className="btn btn-outline w-full text-maroon"><Phone className="h-4 w-4" /> {CONTACT.phoneDisplay}</a>
      </div>
    </aside>
  </div>
);
